import { type PropsWithChildren, Suspense } from 'react'
import { SpinnerLoader } from 'shared/ui/Loader/ui/SpinnerLoader'
import styles from './styles.module.scss'

export const SuspenseWithFallback = ({ children }: PropsWithChildren) => {
  return (
    <Suspense
      fallback={
        <div className={styles.wrap}>
          <SpinnerLoader ariaLabel={'SuspenseWithFallback'} />
        </div>
      }
    >
      {children}
    </Suspense>
  )
}
